import type { FC, ReactNode } from "react";

import styled from "styled-components";

import { EllipsisDropdownItem } from "@similarweb/ui-components";
import type { IEllipsisDropdownItemProps } from "@similarweb/ui-components";

export const StyledDropdownItem = styled<FC<IEllipsisDropdownItemProps & { children?: ReactNode }>>(
    EllipsisDropdownItem,
)`
    height: 42px;
    width: 300px;
`;
